// Import all views here
import exampleView from './views/example';
import project from './views/project';
import home from './views/home';
import impact from './views/impact';
import ourApproach from './views/our-approach';
import events from './views/events';
import collaboration from './views/collaboration';

export default [exampleView, project, home, impact, ourApproach, events, collaboration];
